import { render } from "./ExportationType.vue?vue&type=template&id=767ea18d"
import script from "./ExportationType.vue?vue&type=script&lang=js"
export * from "./ExportationType.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__